import React from 'react';
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Typography,
  Chip,
} from '@material-ui/core';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';
import StakeholderDetails from './StakeholderDetails';
import axios from '../../axios';
import BuzzInput from '../../components/BuzzInput/BuzzInput';
import { getFinanceManagementTableAsync } from './ManagementAppFinance/ManagementAppFinanceStore/managementAppFinanceSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 500,
  minHeight: 145,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export const MANAGEMENT_FINANCE_TABLE_COLUMN = [
  { Header: 'Trans. ID', accessor: 'transactionId' },
  { Header: 'Reference Number', accessor: 'referenceNumber' },
  //   { Header: 'Invoice Number', accessor: 'invoiceId' },
  {
    Header: 'Paid To',
    accessor: 'beneficiary',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { beneficiary } = payload;
      return (
        <Box style={{ wordWrap: 'break-word' }} maxWidth={80}>
          {beneficiary}
        </Box>
      );
    },
  },
  {
    Header: 'Paid By',
    accessor: 'benefactor',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { benefactor } = payload;
      return (
        <Box style={{ wordWrap: 'break-word' }} maxWidth={80}>
          {benefactor}
        </Box>
      );
    },
  },
  {
    Header: 'Amount',
    accessor: 'amount',
  },
  {
    Header: 'Particulars',
    accessor: 'particulars',
  },
  {
    Header: 'Credit/Debit',
    accessor: 'type',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { type } = payload;
      return (
        <>
          <Box display="flex">{type === 'invoice' ? 'Debit' : 'Credit'}</Box>
        </>
      );
    },
  },
  {
    Header: 'Branch Name',
    accessor: 'schoolName',
  },
  {
    Header: 'Date of trans.',
    accessor: 'dateOfTransaction',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { dateOfTransaction } = payload;
      return (
        <>
          <Box display="flex">
            {dateOfTransaction
              ? moment(dateOfTransaction).format('DD MMM YYYY')
              : ''}
          </Box>
        </>
      );
    },
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;

      const { _id, status, particulars, metaData } = payload;

      const [anchorEl, setAnchorEl] = React.useState(null);
      const dispatch = useDispatch();
      const [open1, setOpen1] = React.useState(false);
      const handleOpen1 = () => setOpen1(true);
      const handleClose1 = () => setOpen1(false);

      const [giftVoucherId, setGiftVoucherId] = React.useState('');

      const open = Boolean(anchorEl);

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };
      const ITEM_HEIGHT = 48;

      const handleGiftVoucherStatusChange = async () => {
        try {
          const res = await axios({
            method: 'POST',
            url: 'finances/issue/giftvoucher',
            params: {
              combinedInvoicesId: _id,
            },
            data: { giftVoucherId },
          });

          if (res.status == '200') {
            toast.success(res.data.message);
          }

          dispatch(getFinanceManagementTableAsync());
        } catch (error) {
          toast.error(error.message);
        }
      };

      return (
        <Box display="flex">
          <Box width={80} fontSize={14}>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '20ch',
                },
              }}>
              <MenuItem onClick={handleOpen1}>View Details</MenuItem>
            </Menu>
          </Box>
          <Modal
            open={open1}
            onClose={handleClose1}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <>
              <CloseIcon />
              <Box sx={style}>
                <Typography variant="h5">
                  <Box fontWeight={'fontWeightMedium'}>Invoice Details</Box>
                </Typography>
                <Box my={1} />
                <Box>
                  <Chip label={particulars} />
                  {status == 'paid' ? (
                    <Chip
                      label="Paid"
                      style={{
                        backgroundColor: 'green',
                        color: 'white',
                        marginLeft: '0.5rem',
                      }}
                    />
                  ) : (
                    <Chip
                      label="Un Paid"
                      style={{
                        backgroundColor: 'red',
                        color: 'white',
                        marginLeft: '0.5rem',
                      }}
                    />
                  )}
                </Box>
                {/* <Typography fontWeight={'400'}>Type: {particulars}</Typography> */}

                <Box display={'flex'} my={2} style={{ gap: '1rem' }}>
                  <Box sx={{ width: '50%', height: '100%' }}>
                    <Typography fontWeight={'fontWeightMedium'}>
                      Beneficiary
                    </Typography>
                    <Box
                      sx={{
                        border: '1px solid black',
                        padding: '1rem',
                        height: '100%',
                      }}>
                      <StakeholderDetails
                        data={metaData && metaData.beneficiaryDetails}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ width: '50%', height: '100%' }}>
                    <Typography fontWeight={'fontWeightMedium'}>
                      Benefactor
                    </Typography>
                    <Box
                      sx={{
                        border: '1px solid black',
                        padding: '1rem',
                        height: '100%',
                      }}>
                      <StakeholderDetails
                        data={metaData && metaData.benefactorDetails}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box my={1} style={{ display: 'flex', alignItems: 'center' }} />
                {/* && !metaData.issuedGiftVoucher */}

                {particulars === 'Referral' && metaData && (
                  <>
                    {metaData.issuedGiftVoucher ? (
                      <>
                        <Typography>
                          {' '}
                          Gift Voucher Status:{' '}
                          <Chip
                            label="Dispatched"
                            style={{
                              backgroundColor: 'green',
                              color: 'white',
                              marginLeft: '0.5rem',
                            }}
                          />
                        </Typography>
                        <Typography style={{ marginTop: '0.5rem' }}>
                          {' '}
                          Gift Voucher Id: {metaData.giftVoucherId}
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Box>
                          <Typography>
                            {' '}
                            Gift Voucher Status:{' '}
                            <Chip
                              label="Not Dispatched"
                              style={{
                                backgroundColor: 'red',
                                color: 'white',
                                marginX: '0.5rem',
                              }}
                            />
                          </Typography>
                        </Box>
                        <Box
                          my={1}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem',
                          }}>
                          <Typography>
                            If dispatched already,
                            {/* <BuzzInput></BuzzInput> */}
                          </Typography>
                          <BuzzInput
                            size="small"
                            placeholder="Gift Voucher Id"
                            value={giftVoucherId}
                            onChange={(e) =>
                              setGiftVoucherId(e.target.value)
                            }></BuzzInput>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleGiftVoucherStatusChange()}
                            disabled={status == 'paid' ? false : true}>
                            Dispatched
                          </Button>
                        </Box>
                      </>
                    )}
                  </>
                  // </Typography>
                )}
              </Box>
            </>
          </Modal>
        </Box>
      );
    },
  },
];
